import { Controller } from '@hotwired/stimulus';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import 'tippy.js/themes/light-border.css';

export default class extends Controller {
  connect() {
    this.tippyInstances = [];
    const elements = document.querySelectorAll(
      '[aria-label]:not(.choices__button):not(trix-editor), [data-tooltip]',
    );
    for (const element of elements) {
      const content =
        this.templateHTML(element) ||
        element.getAttribute('aria-label') ||
        element.innerHTML;

      const instance = tippy(element, {
        content,
        allowHTML: true,
        arrow: true,
        theme: 'light-border',
        maxWidth: 400,
        animation: 'scale',
      });
      this.tippyInstances.push(instance);
    }
  }

  disconnect() {
    if (!this.tippyInstances) return;
    Array.from(this.tippyInstances).forEach((instance) => {
      if (instance) instance.destroy();
    });
  }

  templateHTML(element) {
    const data = element.getAttribute('data-tooltip');
    if (!data) return;

    const template = document.getElementById(data);
    if (!template) return;

    return template.innerHTML;
  }
}
